module.exports = __webpack_public_path__ + "static/media/tachometer-average.0f5ab5dc.svg";